import { gql } from 'graphql-request';

import AudioFragment from '../Audio/AudioFragment';
import PrimaryVisualsFragment from '../PrimaryVisuals/PrimaryVisualsFragment';
import ContributorsFragment from '../Contributors/ContributorFragment';

const QUERY = gql`
  query Favorites($contentAreaSlug: String!, $contentIds: [String]) {
    contentList(
      contentIds: $contentIds
      contentAreaSlug: $contentAreaSlug
    ) {
      totalItems
      totalPages
      items {
        id
        title
        subtitle
        canonicalSlug
        resourceType
        publishDate
        descriptionText
        contributors {
          ${ContributorsFragment}
         }
        primaryVisuals {
          ${PrimaryVisualsFragment}
        }
        audio {
         ${AudioFragment}
        }
        ... on Episode {
          primaryCollection {
            title
            canonicalSlug
            resourceType
          }
          primaryAudio {
            ${AudioFragment}
          }
        }
        ... on Story {
          shortTitle
          primaryCollection {
            title
            canonicalSlug
            resourceType
          }
          primaryAudio {
            ${AudioFragment}
          }
        }
        ... on Collection {
          results { 
            items {
              id
              resourceType
              publishDate
              title
              descriptionText
              canonicalSlug
              primaryVisuals {
                ${PrimaryVisualsFragment}
              }
            }
          }
        }
      }
    }
  }
`;

export default QUERY;
